import React from 'react';
import TeacherDashboardPage from '../../../subsreens/gcstaff/staffdashboard/TeacherDashboardPage';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';


const StaffDashboard = () => {
    return (
        <TeacherMasterLayout>
            <TeacherDashboardPage />
        </TeacherMasterLayout>
    )
}

export default StaffDashboard;